export default __webpack_public_path__ + "media/src/assets/images/Phone-8b0390deac423284146bd788e731515c.svg";